// Classifies a citation row from /aim/citation-sources into one of six
// buckets the Content tab's "Type" column renders. Precedence is meaningful:
//   1. own  - is_client_site=true on the row (highest priority)
//   2. ota  - travel aggregators (OTA_DOMAINS regex)
//   3. serp - search-engine result pages (SERP_DOMAINS regex)
//   4. social   - social media surfaces (markup #74)
//   5. government - .gov / .mil and country-suffixed variants (markup #80)
//   6. other - everything else, falls through
//
// Each match below excludes the higher-priority hits so a hypothetical
// "facebook.gov" domain (unusual but legal) would resolve to social first.

const OTA_DOMAINS = /thedyrt|tripadvisor|hipcamp|campendium|booking\.com|expedia|kayak|airbnb|yelp/i;
const SERP_DOMAINS = /^(?:www\.)?(?:google|bing|duckduckgo|yahoo)\.[a-z.]+$/i;
const SOCIAL_DOMAINS = /^(?:www\.|m\.)?(?:facebook|fb|twitter|x|instagram|linkedin|pinterest|tiktok|reddit|threads|youtube|youtu\.be)\.[a-z.]+$/i;
const GOV_DOMAINS = /\.(?:gov|mil)(?:\.[a-z]{2})?$/i;

export function classifyCitation({ domain, is_client_site } = {}) {
  if (is_client_site) return 'own';
  const d = String(domain || '');
  if (OTA_DOMAINS.test(d)) return 'ota';
  if (SERP_DOMAINS.test(d)) return 'serp';
  if (SOCIAL_DOMAINS.test(d)) return 'social';
  if (GOV_DOMAINS.test(d)) return 'government';
  return 'other';
}

export const CITATION_TYPE_LABEL = {
  own: 'Your site',
  ota: 'OTA',
  serp: 'SERP',
  social: 'Social',
  government: 'Government',
  other: 'Other',
};

export const CITATION_TYPE_CLASS = {
  own: 'text-emerald-600 dark:text-emerald-400',
  ota: 'text-amber-600 dark:text-amber-400',
  serp: 'text-blue-600 dark:text-blue-400',
  social: 'text-pink-600 dark:text-pink-400',
  government: 'text-violet-600 dark:text-violet-400',
  other: 'text-gray-600 dark:text-gray-400',
};
